export default __webpack_public_path__ + "static/media/token-icon-1.c5a3a4ae.svg";